export const pageData = {
	slugHome: "Home",
	slugPage: "Product Detail Page",
	navCategory: "Navigation Category A",
	navItem: "Navigation Item A",
	tagHead: "Tags:",
	tags: ["Kitchen", "L-Shape", "Sustainable"],
	productName: "Product Name ABC",
	productSub: "Product Category Name(Example: Plywood)",
	ratingAvg: 4.4,
	ratingCount: 328,
	ratingText: "reviews",
	buildText: "Build My Project",
	price: "Rs.2100.00",
	priceText: "per sheet",
	image: [
		"https://i.kym-cdn.com/photos/images/newsfeed/001/725/807/cef.png",
		"https://i.redd.it/p7e9jyxsxjv61.jpg",
		"https://img-comment-fun.9cache.com/media/avPGm5W/aXPLK4nD_700w_0.jpg",
		"https://www.telegraph.co.uk/content/dam/art/2021/05/03/Space-Cat_trans_NvBQzQNjv4BqvqfDbYV_7XcRT56v9L25rAk82TRM0xi_N4x7ucCy1vw.png",
		"https://cdni.rbth.com/rbthmedia/images/2021.05/original/60b4cf3985600a50dd341bb7.jpg",
	],
	imageOne: "https://i.kym-cdn.com/photos/images/newsfeed/001/725/807/cef.png",

	productDesHead: "Product Description",
	productDesBody:
		"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
	availText: "Available online:",
	availCount: "189",
	counterText: "Quantity",
	counterIntial: 1,
	cartButtonText: "Add to cart",
	tabHeaders: ["Product Specifications", "Reviews", "FAQs"],
};
